import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
	providedIn: 'root',
})
export class ErrorService {
	_httpLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
	httpLoading$: Observable<boolean> = this._httpLoading.asObservable();
	private _permissionDeniedUntil = 0;

	constructor(private _http: HttpClient) {}

	markPermissionDenied(cooldownMs = 1200): void {
		this._permissionDeniedUntil = Date.now() + cooldownMs;
	}

	shouldSuppressGenericErrorToast(): boolean {
		return Date.now() <= this._permissionDeniedUntil;
	}

	loading(): any {}
}
